export const state = (name = 'local', initialValue = null) => {
    const obj = {
        loaded: false,
        value: initialValue
    };

    obj.load = () => {
        const local = localStorage.getItem(name);
        if (local == null) localStorage.setItem(name, JSON.stringify(initialValue));
        obj.value = local ? JSON.parse(local) : initialValue;
        obj.loaded = true;
    };

    obj.set = (value) => {
        const currentValue = obj.get();
        const newValue = typeof value === 'function' ? value(currentValue) : value;
        localStorage.setItem(name, JSON.stringify(newValue));
        obj.value = newValue;
    };

    obj.get = () => {
        if (!obj.loaded) obj.load();
        return obj.value;
    };

    obj.reset = () => {
        localStorage.setItem(name, JSON.stringify(initialValue));
    };

    obj.drop = () => {
        localStorage.removeItem(name);
    };

    return obj;
};
